// extracted by mini-css-extract-plugin
export default {"cards":"kkiEN6I3H9KpuctoivEg","tile":"ONdrbLl8XpWmHH4gDJ51"};